import React, { Component, useContext } from 'react';
import '../index.css';
import ShopModeContext from '../contexts/ShopModeContext';

function Goods({ product, handleCheckProduct, selectedProduct, makeshopURL }) {
  const { shopMode } = useContext(ShopModeContext);

  const productName = product.product_name;
  const productPrice =
    shopMode === 'cafe24' ? product.price : product.sellprice;

  const productDiscountPrice =
    shopMode === 'cafe24'
      ? product.discountprice.pc_discount_price
      : product.discount
      ? product.discount.discount_price
      : 0;

  const productImage =
    shopMode === 'cafe24'
      ? product.list_image
      : makeshopURL + product.tinyimage;

  const display =
    shopMode === 'cafe24' ? product.display === 'T' : product.display === 'Y';

  const selling =
    shopMode === 'cafe24'
      ? product.selling === 'T'
      : product.sell_accept === 'Y';

  const isSelected = selectedProduct?.product_name === productName;

  const getDiscountInfo = () => {
    if (shopMode === 'cafe24') {
      if (productPrice === productDiscountPrice) {
        return '';
      } else {
        return `할인 ${
          ((productPrice - productDiscountPrice) / productPrice) * 100
        }%`;
      }
    }
    if (shopMode === 'makeshop') {
      if (product.discount) {
        if (product.discount.unit === 'price') {
          return `할인 ${product.discount.discount_price}원`;
        } else {
          return `할인 ${product.discount.discount_price}%`;
        }
      }
    }
  };

  return (
    <div
      className="my-videos"
      style={{
        display: 'flex',
        flexDirection: 'row',
        width: 460,
        height: 132,
        marginBottom: 20,
      }}
      onClick={handleCheckProduct}
    >
      <div
        style={{
          width: 132,
          height: 132,
          borderRadius: 3,
          marginRight: 20,
          border: '0.3px solid #000000',
        }}
      >
        <img
          alt="상품 이미지"
          width={130}
          height={130}
          src={productImage}
          style={{ borderRadius: 3, marginRight: 20, overflow: 'hidden' }}
        />
      </div>
      <div
        className="my-videos-buttons"
        style={{
          width: 132,
          height: 132,
          padding: 5,
          border: '5px #FFB600 solid',
          display: 'flex',
          flexDirection: 'row',
          position: 'absolute',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 3,
        }}
      >
        <img src={require('../icons/hover_item_check.svg').default} alt={''} />
      </div>
      {isSelected ? (
        <div
          style={{
            width: 132,
            height: 132,
            padding: 5,
            border: '5px #FFB600 solid',
            display: 'flex',
            flexDirection: 'row',
            position: 'absolute',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 3,
          }}
        >
          <img
            src={require('../icons/hover_item_check.svg').default}
            alt={''}
          />
        </div>
      ) : null}
      <div>
        {display && selling ? (
          <div
            style={{
              width: 90,
              height: 30,
              borderRadius: 20,
              backgroundColor: '#FF9000',
              borderWidth: 0,
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <p
              style={{
                fontWeight: 'bold',
                color: 'white',
                fontSize: 16,
              }}
            >
              진열 상품
            </p>
          </div>
        ) : (
          <div
            style={{
              width: 105,
              height: 30,
              borderRadius: 20,
              backgroundColor: '#CCCCCC',
              borderWidth: 0,
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <p style={{ fontWeight: 'bold', color: 'white', fontSize: 16 }}>
              {selling ? '미진열 상품' : '미판매 상품'}
            </p>
          </div>
        )}

        <p style={{ marginTop: 12, fontSize: 20 }}>{productName}</p>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginTop: 28,
          }}
        >
          <p style={{ fontWeight: 'bold', fontSize: 20 }}>
            {Math.floor(productPrice).toLocaleString()}원
          </p>
          <p style={{ color: 'red', marginLeft: 7.5 }}>{getDiscountInfo()}</p>
        </div>
      </div>
    </div>
  );
}
export default Goods;
